module.exports = __webpack_public_path__ + "static/media/Nota haz dulce el regreso a clases.0c711f86.png";